import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-expired-link',
  templateUrl: './expired-link.component.html',
  styleUrls: ['../_auth.scss']
})
export class ExpiredLinkComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
